import React, { useEffect } from 'react';
import { useNotification } from '../../contexts/NotificationContext';

interface SocketManagerProps {
  isAuthenticated: boolean;
  user: any;
}

const SocketManager: React.FC<SocketManagerProps> = ({ isAuthenticated, user }) => {
  const { disconnectSocket } = useNotification();
  useEffect(() => {
    if (!isAuthenticated) {
      console.log('User logged out, disconnecting socket...');
      disconnectSocket();
    }
  }, [isAuthenticated, disconnectSocket]);
  return null;
};

export default SocketManager; 